import cookie from "./_cookie";

const breadcrumbs = document.querySelector('.js-breadcrumbs');
const link = breadcrumbs ? breadcrumbs.querySelector('a') : false;
const linkText = breadcrumbs ? breadcrumbs.querySelector('.js-breadcrumbs-text'): false;
const pdp = breadcrumbs ? breadcrumbs.dataset.breadcrumbspdp : false;

if (breadcrumbs && link) {
    const collectionTitle = link.dataset.title;
    const collectionUrl = link.dataset.url;

    if(cookie.get('breadcrumbTitle') && cookie.get('breadcrumbTitle') !== collectionTitle && linkText !== null && cookie.get('breadcrumbPage') !== 'productpage') {
        linkText.innerHTML = cookie.get('breadcrumbTitle');
        link.href = cookie.get('breadcrumbUrl');
    }

    if(collectionTitle !== '') {
        cookie.set('breadcrumbTitle', collectionTitle, 1);
        cookie.set('breadcrumbUrl', collectionUrl, 1);
    }

    if(pdp) {
        cookie.set('breadcrumbPage', 'productpage', 1);
    }else {
        cookie.set('breadcrumbPage', 'collectionpage', 1);
    }
}

